import * as React from 'react';
import { analyticsEvents } from '../../../../utils/analytics';
import { AnalyticsLink } from '../../../ui/AnalyticsLink';
import { urls } from '../../../../config';

export default function AppBadges() {
  return (
    <div className="flex flex-row justify-start-l column-center-xxs">
      <AnalyticsLink
        analyticsEvent={analyticsEvents.webReferrals.marketingPageReferral}
        analyticsData={{ component: 'AppBadges' }}
        className="dib ma0 mb2-ns mb3 mr4"
        target="_blank"
        href={urls.playStore}
      >
        <img
          style={{ height: '45px', flexBasis: '100px' }}
          src={require('../../../../assets/img/google-play-badge.png')}
        />
      </AnalyticsLink>

      <AnalyticsLink
        analyticsEvent={analyticsEvents.webReferrals.marketingPageReferral}
        analyticsData={{ component: 'AppBadges' }}
        className="dib ma0 mb2-ns mb3"
        target="_blank"
        href={urls.appStore}
      >
        <img
          style={{ height: '45px', flexBasis: '100px' }}
          src={require('../../../../assets/img/Download_on_the_App_Store_Badge.svg')}
        />
      </AnalyticsLink>
    </div>
  );
}
